import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemMaster } from '../../../shared/models/item.master.interface';
import { NgForm } from '@angular/forms';
import { ItemBulkUpdate } from '../../models/item.bulk.update.interface';
import { BulkUpdateData } from '../models/bulk-update.interface';
import { ItemUpdateTarget_Enum } from '../../enums/item-update-target.enum';

@Component({
  selector: 'app-bulk-update',
  templateUrl: './bulk-update.component.html',
  styleUrls: ['./bulk-update.component.scss']
})
export class BulkUpdateComponent implements OnInit {
  items = [];
  updateTarget: string;

  constructor(private adminService: AdminService, public itemDialogRef: MatDialogRef<BulkUpdateComponent>, @Inject(MAT_DIALOG_DATA) public data: BulkUpdateData) { }

  ngOnInit(): void {
    this.items = this.data.items as ItemMaster[];
  }

  
  bulkUpdate(form: NgForm) {
    console.log("bulk item update");
    let selectedItems = [];
    this.items.forEach((value) => {
      selectedItems.push(value.item_ID);
    });

    if (form.value.priceAjustmentType == "" ||
      form.value.priceAdjustmentAmount == "" ||
      selectedItems.length == 0) {
      return;
    }

    let itemBulkUpdate = {
      dealerId:  this.adminService.getDealerId(),
      priceAdjustmentType: form.value.priceAdjustmentType,
      priceAdjustmentAmount: form.value.priceAdjustmentAmount == "" ? null : form.value.priceAdjustmentAmount,
      itemsToUpdate: selectedItems,
      bulkChangeDetails: this.data.itemFilter
    } as ItemBulkUpdate;

    if (this.data.itemUpdateTarget == ItemUpdateTarget_Enum.ItemMaster) {
      this.adminService.itemBulkUpdate(itemBulkUpdate)
        .subscribe(result => {
          console.log('items Updated from bulk update = ' + result);
          this.itemDialogRef.close();
        });
    }
    else if (this.data.itemUpdateTarget == ItemUpdateTarget_Enum.IDIItemSource) {
      this.adminService.idiItemBulkUpdate(itemBulkUpdate)
        .subscribe(result => {
          console.log('items Updated from bulk update = ' + result);
          this.itemDialogRef.close();
        });
    }

  }

  onNoClick(): void {
    this.itemDialogRef.close();
  }
}
